import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=c968f326&"
import script from "./Services.ts?vue&type=script&lang=js&"
export * from "./Services.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports